<!--
 * @Author: qinmengyuan
 * @Date: 2024-04-08 17:27:02
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-07-31 17:23:42
 * @FilePath: \onetab\src\components\AddCategory.vue
-->
<template>
  <div class="mask" @click.self="handleClose">
    <Transition name="modal-fade">
      <div class="categroy-bar" v-if="isShow" ref="modalRef">
        <div class="title">{{ props.detail?.uuid ? '编辑' : '添加'}}分类<Close @click="handleClose" /></div>
        <div style="width: 100%;">
          <RaSelect v-model="catType" style="width: 100%">
            <RaOption value="1" label="个人分类" />
            <RaOption value="2" label="共享分类" v-if="!props.detail?.name && user.token" />
          </RaSelect>
        </div>
        <RaInput
          v-if="catType == 1"
          ref="inputRaf"
          placeholder="分类名称"
          v-model="name"
          autofocus
        />
        <div v-if="catType == 1" class="icon-text" @click="showIcons = !showIcons">
          <span>图标</span>
          <div class="text-right">
            <i
              :class="`iconfont ${
                iconValue?.includes?.('icon-onetabicon')
                  ? iconValue
                  : `icon-onetabicon-${iconValue}`
              }`"
            ></i
            ><Right :class="{ down: showIcons }" />
          </div>
        </div>
        <div v-if="catType == 1" :class="{ transition: true, hidden: !showIcons }">
          <div class="icon-cont">
            <div
              v-for="item in 35"
              :key="item"
              :class="{ item: true, active: iconValue == item }"
              @click="handleIcon(item)"
            >
              <i
                :class="`iconfont icon-onetabicon-${
                  item > 9 ? item : `0${item}`
                }`"
              ></i>
            </div>
          </div>
        </div>
        <div v-if="catType == 1 && user.token" class="share-options">
          <RaCheckbox v-model="isShare" :true-label="1" :false-label="0" style="font-size: 13px;">
            设为共享分类
          </RaCheckbox>
          <div class="share-btn" @click="copyShareCode" v-show="isShare && shareCode">
            复制共享码
          </div>
        </div>
        <RaInput v-model="inputShareCode" placeholder="请输入共享码" v-if="catType == 2"></RaInput>
        
        <div class="btn-cont">
          <RaButton class="btn-style" status="tertiary" @click="handleClose"
            >取消</RaButton
          >
          <RaButton
            class="btn-style"
            @click="props.detail?.name ? handleEdit() : newCategory()"
            :loading="isLoading"
            :disabled="disabledSubmit"
            >保存</RaButton
          >
        </div>
      </div>
    </Transition>
  </div>
</template>

<script ts="lang" setup>
import { ref, onMounted, watch, onBeforeUnmount, nextTick } from 'vue';
import { Close, Right } from '@rafter/icon';
import { RaInput, RaButton, RaMessage, RaSelect, RaOption, RaCheckbox } from '@rafter/pc';
import { syncToLocal, addShareCode, addRemoteCategory, putRemoteCategory } from '@/api/baseApi';
import { bookmarks } from '@/store/bookmarks';
import Util from '@/lib/Util';
import { user } from '@/store/user';
const modalRef = ref();
const emits = defineEmits(['refresh', 'handleClose']);
const showIcons = ref(false);
const iconValue = ref('01');
const name = ref('');
const uuid = ref('');
const catType = ref('1');
const isShow = ref(false);
const isShare = ref(0);
const originShare = ref(0);
const shareCode = ref('');
const inputShareCode = ref('');
const isLoading = ref(false);
const disabledSubmit = ref(false);
const props = defineProps({
  detail: {
    type: Object,
    default: () => ({}),
  },
});
const inputRaf = ref();
const handleIcon = (item) => {
  iconValue.value = item > 9 ? `${item}` : `0${item}`;
};
const handleEdit = () => {
  if (!name.value) {
    RaMessage({
      type: 'error',
      message: '请输入分类名称',
    });
    return;
  }

  isLoading.value = true;
  putRemoteCategory(uuid.value, {
    name: name.value,
    icon: iconValue.value.includes('icon-onetabicon')
      ? iconValue.value
      : `icon-onetabicon-${iconValue.value}`,
    is_share: isShare.value,
  }, false).then((res) => {
    isLoading.value = false;
    res.is_share = isShare.value;
    bookmarks.updateCategory(res);
    emits('refresh');
    
    if(originShare.value != isShare.value && isShare.value){
      disabledSubmit.value = true;
      shareCode.value = res.share_code;
      RaMessage({
        message: '操作成功，可复制共享码',
        type: 'success',
      });
    }else{
      RaMessage({
        message: '修改成功',
        type: 'success',
      });
      handleClose();
    }
  });
};
const handleClose = () => {
  isShow.value = false;
  setTimeout(() => {
    emits('handleClose');
  }, 150);
};
const newCategory = () => {
  if(catType.value == 1) {
    if (!name.value) {
      RaMessage({
        type: 'error',
        message: '请输入分类名称',
      });
      return;
    }

    isLoading.value = true;
    addRemoteCategory({
      name: name.value,
      icon: `icon-onetabicon-${iconValue.value}`,
      order: bookmarks.categories.length + 1,
      is_share: isShare.value,
    }).then((res) => {
      isLoading.value = false;
      res.bookmarks = [];
      bookmarks.addCategory(res);
      emits('refresh');
      
      if(originShare.value != isShare.value && isShare.value){
        disabledSubmit.value = true;
        shareCode.value = res.share_code;
        RaMessage({
          message: '操作成功，可复制共享码',
          type: 'success',
        });
      }else{
        handleClose();
      }
    });
  }else{
    if (!inputShareCode.value) {
      RaMessage({
        type: 'error',
        message: '请输入共享码',
      });
      return;
    }
    isLoading.value = true;
    addShareCode({
      shareCode: inputShareCode.value,
    })
    .then(res=>{
      if(res.data.code === 200){
        syncToLocal().then(()=>{
          isLoading.value = false;
          handleClose();
        });
      }else{
        isLoading.value = false;
        RaMessage({
          type: 'error',
          message: res.data.msg,
        });
      }
    })
    .catch(err=>{
      isLoading.value = false;
      RaMessage({
        type: 'error',
        message: '请求失败',
      });
    });
  }
};
watch(
  () => [props.detail],
  () => {
    if (props.detail) {
      name.value = props.detail?.name;
      uuid.value = props.detail?.uuid;
      iconValue.value = props.detail?.icon;
      catType.value = props.detail?.shrea_origin_uuid ? '2' : '1';
      isShare.value = props.detail?.is_share;
      shareCode.value = props.detail?.share_code;
      originShare.value = shareCode.value;
    }
  }
);
onMounted(() => {
  isShow.value = true;
  if (props.detail) {
    name.value = props.detail?.name;
    uuid.value = props.detail?.uuid;
    iconValue.value = props.detail?.icon;
    catType.value = props.detail?.shrea_origin_uuid ? '2' : '1';
    isShare.value = props.detail?.is_share;
    shareCode.value = props.detail?.share_code;
    originShare.value = shareCode.value;
  }
  document.addEventListener('keydown', handleKeyDown);
  nextTick(() => {
    inputRaf.value.focus();
  });
});
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

const copyShareCode = (()=>{
  Util.copyToClipboard(shareCode.value);
  RaMessage({
    message: '复制成功',
    type: 'success',
  });
});
</script>
<style lang="scss" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  background-color: rgba(26, 26, 26, 0.4);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.categroy-bar {
  display: flex;
  width: calc(320px - 48px);
  height: calc(296px - 40px);
  flex-direction: column;
  align-items: flex-start;
  border-radius: 24px;
  padding: 16px 24px 24px;
  gap: 16px;
  user-select: none;
  position: absolute;
  z-index: 1;
  background: transparent;
  &::before {
    @include background_color('base-bg-color-09');
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(60px);
    z-index: -1;
    border-radius: 24px;
  }
  .title {
    display: flex;
    @include font_color('text-on-surface-secondary');
    align-items: center;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    justify-content: space-between;
    width: -webkit-fill-available;
  }
}
.icon-text {
  width: -webkit-fill-available;
  display: flex;
  padding: 4px 4px 4px 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid var(--border-form, rgba(26, 26, 26, 0.05));
  @include background_color('base-bg-color-09');
  @include font_color('text-on-surface-secondary');
  font-family: 'PingFang SC';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  .text-right {
    display: flex;
    align-items: center;
  }
  .iconfont {
    font-size: 25px;
  }
}
.icon-cont {
  display: flex;
  width: 248px;
  padding: 12px;
  align-items: flex-start;
  //   position: absolute;
  //   top: 150px;
  border-radius: 8px;
  @include background_color('base-bg-color-09');
  backdrop-filter: blur(40px);
  flex-wrap: wrap;
  justify-content: space-between;

  overflow: hidden;
  .item {
    display: flex;
    width: 32px;
    height: 32px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    @include background_color('border-on-surface-overlay');
    margin-bottom: 4px;
    @include font_color('text-on-surface-secondary');
    cursor: pointer;

    &.active {
      @include font_color('one-selected');
    }
    .iconfont {
      font-size: 24px;
    }
  }
}
.transition {
  height: 204px;
  transition: height 0.5s;
  position: absolute;
  top: 190px;
  overflow: hidden;
  z-index: 2;
}
.hidden {
  height: 0px;
  overflow: hidden;
}
.svg-icon {
  transition: transform 0.5s;
}
.down {
  transform: rotate(90deg);
}
.btn-cont {
  display: flex;
  gap: 16px;
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
}
.btn-style {
  width: 128px;
}

.share-options{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;

  .share-btn{
    color: #387FFC;
    cursor: pointer;
    user-select: none;
  }
}
</style>
